export default "__VITE_ASSET__487fb9fb__"